import axiosInstance from "../../lib/axiosInstance";
import { getErrorMessage } from "../../utils/errorUtils";
import {
  setLoadingReminderLogs,
  setReminderLogs,
  setErrorLoadingReminderLogs,
  setReminderLogPagination,
  setServerResponseStatus,
} from "../slices/reminderLog";

export const getReminderLogs =
  ({
    page = 1,
    size = 12,
    search = "",
    startDate = "",
    endDate = "",
    type = "",
  } = {}) =>
  async (dispatch) => {
    dispatch(setLoadingReminderLogs());
    try {
      const params = { page, size };
      if (search) params.search = search;
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (type) params.type = type;

      const { data } = await axiosInstance.get("/reminders", {
        params,
        headers: { requiresAuth: true },
      });

      if (data.status === "SUCCESS") {
        dispatch(setReminderLogs(data.data.content));
        dispatch(setReminderLogPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(setErrorLoadingReminderLogs(getErrorMessage(error)));
    }
  };

export const resetPaymentServerStatus = () => (dispatch) => {
  dispatch(setServerResponseStatus(null));
};
